module.exports = __webpack_public_path__ + "img/ye.5e3627bb.svg";